import {getEnv} from '@config/getEnv';
import {IToken} from '@services/auth/auth.model';
import {convertBase64ToUtf8} from '@utils/convertBase64ToUtf8';
import {importSPKI, jwtVerify} from 'jose';

export const decodeJwt = async (token: string): Promise<IToken> => {
    const publicKeyBase64 = getEnv('NEXT_PUBLIC_JWT_PUBLIC_KEY_BASE_64');
    const publicKeyUTF8 = convertBase64ToUtf8(publicKeyBase64);

    const publicKey = await importSPKI(publicKeyUTF8, 'RS256');

    const {payload: jwtPayload, protectedHeader} = await jwtVerify(
        token,
        publicKey,
    );

    if (!jwtPayload) {
        throw new Error('Invalid token! signature can not be verified.');
    }

    return {
        header: protectedHeader,
        payload: {
            ...jwtPayload,
            exp: jwtPayload.exp ? new Date(jwtPayload.exp * 1000) : undefined,
            now: jwtPayload.now
                ? new Date(Number(jwtPayload.now) * 1000)
                : undefined,
        },
    } as unknown as IToken;
};

export const checkJwtTokenValid = async (token?: string) => {
    if (!token) {
        return false;
    }
    try {
        const decodedToken = await decodeJwt(token);
        return !!decodedToken && decodedToken.payload.exp > new Date();
    } catch (error) {
        return false;
    }
};
